import { TOGGLE_SIDE_NAVIGATION } from '../../mutation-types';

export function toggle({ commit }, { isOpen }) {
    commit(TOGGLE_SIDE_NAVIGATION, { isOpen });
}
